var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CDataTable',{attrs:{"bordered":"","fixed":"","responsive":"","loading":_vm.isLoading,"items":_vm.histories,"fields":_vm.fields,"sorter":false}})}
var staticRenderFns = []

export { render, staticRenderFns }